import { useEffect, useState } from "react"
import Box from "@mui/material/Box"
import IconButton from "@mui/material/IconButton"
import InputBase from "@mui/material/InputBase"
import Popover from "@mui/material/Popover"
import Switch from "@mui/material/Switch"
import Tooltip from "@mui/material/Tooltip"
import Typography from "@mui/material/Typography"
import PersonOutlineIcon from "@mui/icons-material/PersonOutline"
import { CHAT_COLOR, MONO } from "../constants"

export function PresenceControls({ status, dnd, onSave }) {
  const [anchor, setAnchor] = useState(null)
  const [draft, setDraft] = useState(status || "")
  useEffect(() => setDraft(status || ""), [status])
  return (
    <>
      <Tooltip title={dnd ? "Do not disturb" : status || "Set status"} arrow placement="top">
        <IconButton size="small" onClick={(event) => setAnchor(event.currentTarget)} sx={{ color: dnd ? "var(--app-error)" : status ? CHAT_COLOR : "rgba(var(--app-fg-rgb),0.28)" }}>
          <PersonOutlineIcon sx={{ fontSize: 15 }} />
        </IconButton>
      </Tooltip>
      <Popover open={!!anchor} anchorEl={anchor} onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ "data-chat-overlay": "true", sx: { p: 1.25, width: 230, bgcolor: "var(--app-paper)", border: "1px solid rgba(245,158,11,0.2)" } }}>
        <Typography sx={{ fontFamily: MONO, fontSize: "0.58rem", color: "rgba(var(--app-fg-rgb),0.35)", mb: 0.5 }}>CUSTOM STATUS</Typography>
        <InputBase autoFocus value={draft} onChange={(event) => setDraft(event.target.value.slice(0, 64))} placeholder="Im Meeting, AFK…"
          sx={{ width: "100%", fontFamily: MONO, fontSize: "0.7rem", color: "#fff", borderBottom: "1px solid rgba(var(--app-fg-rgb),0.14)" }} />
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mt: 1 }}>
          <Typography sx={{ fontFamily: MONO, fontSize: "0.65rem", color: "rgba(var(--app-fg-rgb),0.65)" }}>Do not disturb</Typography>
          <Switch size="small" checked={dnd} onChange={(event) => onSave(draft.trim(), event.target.checked)} />
        </Box>
        <Box onClick={() => { onSave(draft.trim(), dnd); setAnchor(null) }} sx={{ mt: 1, py: 0.55, textAlign: "center", cursor: "pointer", borderRadius: 1, color: CHAT_COLOR, bgcolor: "rgba(245,158,11,0.1)", fontFamily: MONO, fontSize: "0.65rem" }}>Save</Box>
      </Popover>
    </>
  )
}

export default PresenceControls
